<template>
  <section>
    <b-row>
      <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
        <p class="info-headers">First Name</p>
        <p class="userDetails">
          {{ userDetails.firstName }}
        </p>
      </b-col>
      <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
        <p class="info-headers">Last Name</p>
        <p class="userDetails">
          {{ userDetails.lastName }}
        </p>
      </b-col>
      <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
        <p class="info-headers">
          <b-icon icon="envelope-fill" variant="primary"></b-icon>
          Email
        </p>
        <p class="userDetails">
          {{ selectedEmail || userDetails.emails[0] }}
          <b-icon
            v-if="userDetails.emails != null && userDetails.emails.length > 1"
            icon="pencil"
            style="cursor: pointer"
            variant="primary"
            @click="$bvModal.show('email-pick-modal')"
          ></b-icon>
        </p>
      </b-col>
      <b-col class="mb-2" cols="6" lg="3" md="3" sm="6" xl="3">
        <p class="info-headers">
          <b-icon icon="telephone-fill" variant="primary"></b-icon>
          Phone Number
        </p>
        <p class="userDetails">
          {{ userDetails.phoneNumber }}
        </p>
      </b-col>

      <b-modal id="email-pick-modal" centered ok-only title="Select user's email address">
        <b-form-select
          v-model="selectedEmail"
          :options="userDetails.emails"
          @change="updateSelectedEmail"
        ></b-form-select>
      </b-modal>
    </b-row>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'person-details',
    data() {
      return {
        selectedEmail: '',
      };
    },
    watch: {
      userDetails() {
        this.initialize();
      },
    },
    computed: {
      ...mapGetters(['userDetails']),
      isCustomRequest() {
        return (
          this.$route.name === 'custom-application-access' ||
          this.$route.name === 'application-access-manager-create-request' ||
          this.$route.name === 'anonymous-access-request'
        );
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.selectedEmail = this.isCustomRequest
          ? this.userDetails.selectedEmail
          : this.userDetails.emails[0];
        this.updateSelectedEmail(this.selectedEmail);
      },
      updateSelectedEmail(value) {
        let data = {
          key: 'selectedEmail',
          value: value,
        };
        this.$store.commit('updateUser', data);
      },
    },
  };
</script>

<style scoped>
  .info-headers {
    color: #005db8;
    margin: 0px;
  }
  .userDetails {
    font-size: 14px;
    line-height: 20px;
    color: #006a68;
    margin-bottom: 0px;
  }
</style>
